// import Phaser from 'phaser'
import Config from '../launch/config'
import {isDebug} from '../launch/utils'
import {handleShipClick} from '../app/app'
import {setShipDestination} from './utils'
import audio from '../launch/audio'

export default function handleShipPointerDown(worldX, worldY) {
    const shipBodies = Config.scene.matter.getMatterBodies().filter((body) => {
        const customProps = body[Config.namespace]

        if (!customProps) {
            return false
        }

        if (!customProps.isShipBody) {
            return false
        }

        const ship = Config.ships[customProps.shipId]
        const isFriendly = ship.faction === Config.userFactionName
        const isClickable = isFriendly || (!isFriendly && isDebug)

        return isClickable
    })

    // https://photonstorm.github.io/phaser3-docs/Phaser.Physics.Matter.MatterPhysics.html
    const intersection = Config.scene.matter.intersectPoint(
        worldX,
        worldY,
        shipBodies
    )

    if (intersection.length) {
        const id = intersection[0][Config.namespace].shipId
        const ship = Config.ships[id]

        if (!ship.selected) {
            Config.selectedShips[id] = ship.name
            ship.selected = true
            handleShipClick(ship)
            audio.shipSelect()
            isDebug && console.log(ship)
            return
        }

        ship.selected = false
        delete Config.selectedShips[ship.id]
        handleShipClick(null, true)
    } else {
        let numShips = Object.keys(Config.selectedShips).length
        if (numShips) {
            Object.keys(Config.selectedShips).forEach((key, index) => {
                const ship = Config.ships[key]

                if (!ship.selected) {
                    delete Config.selectedShips[ship.id]
                    return
                }
                ship.selected = false

                // ship.moveLineGraphics && ship.moveLineGraphics.destroy()

                if (ship.type === 'satellite') {
                    delete Config.selectedShips[ship.id]
                    return
                }

                let x = worldX
                let y = worldY

                // Destination offset
                // if (index > 0) {
                //     x = worldX + index * (ship.diameter * 2) + 10
                //     y = worldY + index * (ship.diameter * 2) + 10
                // }

                setShipDestination({
                    numShips,
                    ship,
                    x,
                    y,
                })
                audio.moveMarker()
            })

            handleShipClick(null, true)
        }
    }
}
